import { MUSCLE_SLUGS, type MuscleSlug } from "@heraion/shared";

// What BodyMap's figure can show, read by BodyMap itself and by the pain
// list. Own file so a test that mocks BodyMap still gets the rows.

/** The slugs the figure draws, in MUSCLE_SLUGS order: rnbh has no abductors. */
export const DRAWN_MUSCLES: ReadonlyArray<MuscleSlug> = MUSCLE_SLUGS.filter(
  (s) => s !== "abductors",
);
/** Drawn without halves in rnbh 3.2.0 (all four assets), so never sided. */
export const UNSIDED_MUSCLES: ReadonlySet<MuscleSlug> = new Set<MuscleSlug>(["head"]);
